import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { getInstagramStatus } from '@/services/instagram.service';
import { queryKeys } from '@/hooks/queries/keys';
import type { InstagramConnectionDto } from '@/types/instagram';

type Options = Omit<
    UseQueryOptions<InstagramConnectionDto, unknown, InstagramConnectionDto, ReturnType<typeof queryKeys.instagram.status>>,
    'queryKey' | 'queryFn'
>;

export const useInstagramStatus = (
    params: { withProfile?: boolean } = {},
    options?: Options,
) => {
    const withProfile = params.withProfile ?? false;
    return useQuery({
        queryKey: queryKeys.instagram.status(withProfile),
        queryFn: () => getInstagramStatus(withProfile),
        staleTime: 1000 * 30,
        ...options,
    });
};
